module.exports = {
  /**
   * @description 网站标题
   */
  title: '三天二手车后台管理',
  /**
   * @description 是否显示 tagsView
   */
  tagsView: true,
  /**
   * @description 固定头部
   */
  fixedHeader: true,
  /**
   * @description 记住密码状态下的token在Cookie中存储的天数，默认1天
   */
  tokenCookieExpires: 7,
  /**
   * @description 记住密码状态下的密码在Cookie中存储的天数，默认1天
   */
  passCookieExpires: 7,
  /**
   * @description 是否只保持一个子菜单的展开
   */
  uniqueOpened: true,
  /**
   * @description 是否显示logo
   */
  sidebarLogo: true,
  /**
   * 是否显示设置的底部信息
   */
  showFooter: false,
  /**
   * 底部文字，支持html语法
   */
  footerTxt: '© 2024 天津三天二手车销售有限公司 <a href="http://www.santiancar.cn" target="_blank">Office Registration License 1.0</a>',
  /**
   * 备案号
   */
  caseNumber: '津ICP备2024011205号-1'
}
